import {DomainEvent} from './DomainEvent';
import {StreamEntry} from '../resources/StreamEntry';

export class StreamEntryDeleted extends DomainEvent<StreamEntry> {

}
